import React from "react";
import { MailIcon, RepeatIcon, ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
const points = [{
  icon: MailIcon,
  title: "Digital delivery",
  body: "Your purchase includes access to the six digital volumes and five complementary bonuses. Access instructions are provided right after checkout."
}, {
  icon: RepeatIcon,
  title: "No recurring fees",
  body: "There is no recurring membership fee. One payment, complete collection."
}, {
  icon: ShieldCheckIcon,
  title: "Refund policy",
  body: "Please review the applicable purchase terms displayed during checkout before completing your order."
}];
export function PurchaseInfo() {
  return <section className="bg-white px-4 py-16 sm:py-20" data-id="element-289" data-mp="sl7htal1921m">
      <div className="mx-auto max-w-4xl" data-id="element-290" data-mp="sjmmhiqw9f2p">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-leaf-soft text-cta" data-id="element-291" data-mp="nm499g5ugdow">
          <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-292" data-mp="3lrf21dd3snlk" />
        </div>
        <SectionHeading eyebrow="Your purchase, explained clearly" title="A Practical Educational Resource You Can Explore at Your Own Pace." subtitle="The Autism Communication Support Blueprint™ is designed to provide practical educational reference materials that you can revisit as you organize communication support planning." data-id="element-293" data-mp="3psh2tymo57pn" />
        <ul className="mt-10 grid gap-4 md:grid-cols-3" data-id="element-294" data-mp="32tuc02ylrizd">
          {points.map(({
          icon: Icon,
          title,
          body
        }) => <li key={title} className="rounded-3xl bg-cream p-5" data-id="element-295" data-mp="36vfvw89k0xj2">
              <Icon className="h-7 w-7 text-brand" aria-hidden="true" data-id="element-296" data-mp="3br4otsr2jg6e" />
              <h3 className="mt-3 text-lg font-black text-navy" data-id="element-297" data-mp="3gs2fyuu23kk1">{title}</h3>
              <p className="mt-1.5 text-[15px] font-semibold leading-relaxed text-ink/75" data-id="element-298" data-mp="r2qpgct6aqkn">{body}</p>
            </li>)}
        </ul>
        <div className="mt-10" data-id="element-299" data-mp="w0a2xai1qzbj">
          <CtaButton label="Start my Blueprint™ today" sub="Secure Checkout · One-Time Payment of $27" data-id="element-300" data-mp="w3o5ojumhaji" />
        </div>
      </div>
    </section>;
}